<template>
  <div>
    <ItemsAssociationInput ref="inner" :changeItems="changeItems" :selectionMode="true" />
  </div>
</template>

<script>
import ItemsAssociationInput from '@/components/Globals/Helpers/ItemsAssociationInput'

export default {
  name: 'ItemsAssociationInputSelect',
  components: { ItemsAssociationInput },
  props: {
    changeItems: {
      type: Function,
      required: true
    }
  },
  methods: {
    setSelectedItems(associations) {
      if (this.$refs.inner && this.$refs.inner.setSelectedItems) {
        this.$refs.inner.setSelectedItems(associations)
      }
    }
  }
}
</script>

<style scoped>
</style>